"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrNewsletterFormContainer = void 0;
const pick_1 = __importDefault(require("lodash/pick"));
const next_i18next_1 = require("next-i18next");
const react_1 = __importStar(require("react"));
const fdr_newsletter_form_1 = require("./subscription/fdr-newsletter-form");
const FdrNewsletterFormContainer = props => {
    const { prefillForm, personalData, onHandleSubmit, errorNotification, formDescription, } = props;
    const [t] = (0, next_i18next_1.useTranslation)('newsletter');
    const [error, setError] = (0, react_1.useState)(false);
    const onSubmit = (values, helpers) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const isSubscriptionSucceed = yield onHandleSubmit(values);
            if (!isSubscriptionSucceed)
                setError(true);
        }
        catch (e) {
            setError(true);
        }
        finally {
            helpers.resetForm();
        }
    });
    let initialValues;
    if (prefillForm && personalData) {
        initialValues = (0, pick_1.default)(personalData, 'salutation', 'firstName', 'lastName', 'email');
    }
    return (react_1.default.createElement(fdr_newsletter_form_1.FdrNewsletterForm, { errorNotification: error
            ? errorNotification || react_1.default.createElement("div", null, t('newsletter:subscribe.failure'))
            : undefined, onSubmit: onSubmit, initialValues: initialValues, formDescription: formDescription }));
};
exports.FdrNewsletterFormContainer = FdrNewsletterFormContainer;
//# sourceMappingURL=fdr-newsletter-form-container.js.map